export const fileUploadModalActionTypes = {
  setLoading: 'setLoading',
  setFiles: 'setFiles',
  setSelectedDocumentId: 'setSelectedDocumentId',
  setOpenModal: 'setOpenModal',
  setOptions: 'setOptions',
  setError: 'setError',
  reset: 'reset',
  addFiles: 'addFiles',
  replaceFiles: 'replaceFiles',
  removeFile: 'removeFile',
};
export const fileUploadModalInitialState = {
  loading: false,
  files: [],
  selectedDocumentId: null,
  isOpenModal: false,
  errors: null,
  options: {
    accept: '',
    maxFileSizeMb: 2,
    allFilesMaxSizeMb: 20,
    openDialogOnClick: true,
  },
};

export const fileUploadModalReducer = function (state = fileUploadModalInitialState, action) {
  switch (action.type) {
    case fileUploadModalActionTypes.replaceFiles: {
      return {
        ...state,
        files: action.payload,
        selectedDocumentId: state.selectedDocumentId
          ? state.selectedDocumentId
          : action.payload[0].documentId,
      };
    }

    case fileUploadModalActionTypes.removeFile: {
      const nFiles = state.files.filter((file) => file.documentId !== action.payload);
      return {
        ...state,
        files: nFiles,
        selectedDocumentId: state.selectedDocumentId
          ? state.selectedDocumentId
          : nFiles[0].documentId,
      };
    }

    case fileUploadModalActionTypes.addFiles: {
      const nFiles = [...state.files, ...action.payload];
      return {
        ...state,
        files: nFiles,
        selectedDocumentId: state.selectedDocumentId
          ? state.selectedDocumentId
          : nFiles[0].documentId,
      };
    }
    case fileUploadModalActionTypes.setLoading: {
      return { ...state, loading: action.payload };
    }
    case fileUploadModalActionTypes.setFiles: {
      return { ...state, files: action.payload };
    }
    case fileUploadModalActionTypes.setSelectedDocumentId: {
      return { ...state, selectedDocumentId: action.payload };
    }
    case fileUploadModalActionTypes.setOpenModal: {
      return { ...state, isOpenModal: action.payload };
    }
    case fileUploadModalActionTypes.setOptions: {
      return { ...state, options: action.payload };
    }
    case fileUploadModalActionTypes.setError: {
      return { ...state, errors: action.payload };
    }
    case fileUploadModalActionTypes.reset: {
      return { ...fileUploadModalInitialState };
    }
    default: {
      /* eslint-disable */
      console.log('action wasn`t caught ');
      return state;
    }
  }
};
